type ErrorValue = undefined | string | CustomError;

type ErrorMap<T extends string> = Record<T, ErrorValue>;

function getErrorMessage(error: ErrorValue): undefined | string {
    return typeof error === "string" ? error : error?.getErrorMessage();
}

interface CustomError {
    getErrorMessage(): string;
}

export type { ErrorMap, ErrorValue, CustomError };
export { getErrorMessage };
